import { useAuth0 } from "@auth0/auth0-react";
import { DatePickerField } from "_metronic/_partials/controls";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { HintField, InputField, LabelField, SelectField } from "components";
import { TextareaField } from "components/TextareaField";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import AddInstallmentsPayment from "../../../../components/Installments/AddInstallmentsPayment";
import { MyCheckbox } from "../../../../components/MyCheckbox";
import { PriceType } from "../../NewCharge/ChargeType/PercentageFixed";
import { useFormikContext } from 'formik';
import InfoTooltip from "../../../../components/InfoTooltip";

const File = ({ types, setShow, show, formik, enableInstallments }) => {
  const [search, setSearch] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const { searchAction } = useSearch({ action: setSearch });
  const [ledgers, setLedgers] = useState();
  const [localFormat, setLocalFormat] = useState(false);
  const [taxType, setTaxType] = useState("%");
  const [discountType, setDiscountType] = useState("%");

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();
  const currency = getCurrency();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormat || "mm/dd/yyyy");

  const { setFieldValue } = useFormikContext();

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];
  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  const getSubledgerList = ledgers?.find(
    (x) => x._id === formik?.values?.Ledger?.id
  );
  // Get Ledger Subledger List
  const fetchLedgerSubledgerList = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.getLedgerSubLedgerList(token)
      .then((res) => {
        setLedgers(res?.ledgers);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  useEffect(() => {
    fetchLedgerSubledgerList();
    if (formik?.values.nextpayment === false) {
      formik.setFieldValue(`batch_name`, "");
      formik.setFieldValue(`description`, "");
      formik.setFieldValue(`Ledger`, {
        name: "",
        id: "",
      });
      formik.setFieldValue(`SubLedger`, {
        name: "",
        id: "",
      });
      // formik.setFieldValue(`amount`, "");
      // formik.setFieldValue(`discount`, "");
      // formik.setFieldValue(`tax`, "");
      // formik.setFieldValue(`require_notes`, false);
      // formik.setFieldValue(`note`, "");
      // formik.setFieldValue(`is_splitted`, false);
      // formik.setFieldValue(`split_duration`, "");
      // formik.setFieldValue(`split_amount`, "");
      // formik.setFieldValue("due_date", "");
    }
  }, []);
  const subLegderOptions = getSubledgerList?.sub_ledgers?.map((item) => {
    return {
      label: item?.sub_ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  const legderOptions = ledgers?.map((item) => {
    return {
      label: item?.ledger_name,
      value: item?._id,
      amount: item?.default_amount,
      notes: item?.notes,
    };
  });
  useEffect(() => {
    formik.setFieldValue(`batch_type`, show?.toLowerCase());
  }, [show]);
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const getSubLedgerOnChange = async (event) => {

    if (!event) {
      formik.setFieldValue(`SubLedger`, {
        id: "",
        name: "",
      });
      const currentLedger = legderOptions.find(
        (item) => item.value === formik.values?.Ledger?.id
      );
      if (currentLedger) {
        formik.setFieldValue(`amount`, currentLedger.amount);
        formik.setFieldValue(`require_notes`, currentLedger.notes);
      }
      return;
    }
    formik.setFieldValue(`SubLedger`, {
      id: event.value,
      name: event.label,
    });
    formik.setFieldValue(`amount`, event?.amount);
    formik.setFieldValue(`require_notes`, event?.notes);
    console.log("formik.values", formik.values);
    //  formik.setFieldValue(`amount`, event?.default_amount);

    //  //  formik.setFieldValue(`amount`, );
    //  const current = legderOptions.find(
    //    (item) => item.options.indexOf(event) !== -1
    //  );
    //  if (current) {
    //    formik.setFieldValue(`Ledger`, {
    //      id: current.value,
    //      name: current.label,
    //    });
    //    formik.setFieldValue(`amount`, current.options[0]?.amount);
    //  }
  };
  const getLedgerOnChange = async (event) => {
    // formik.setFieldValue(`SubLedger`, {
    //   id: event.value,
    //   name: event.label,
    // });
    // formik.setFieldValue(`amount`, event?.default_amount);

    // //  formik.setFieldValue(`amount`, );
    // const current = legderOptions.find(
    //   (item) => item.options.indexOf(event) !== -1
    // );
    // if (current) {
    formik.setFieldValue(`Ledger`, {
      id: event?.value,
      name: event?.label,
    });
    formik.setFieldValue(`SubLedger`, "");
    // formik.setFieldValue(`amount`, event?.amount);
    // formik.setFieldValue(`require_notes`, event?.notes);
  };


  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }
  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  // useEffect(() => {
  //   if (formik.values?.discount_type === "%" && formik.values?.discount >= 100) {
  //     toastr.error("Validation", "discount should be less than 100%")
  //     formik.setFieldValue("discount", 0)
  //   }
  // }, [formik.values?.discount_type])

  // useEffect(() => {
  //   if (formik.values.amount < formik.values.discount && formik.values?.discount_type === "$") {
  //     formik.setFieldValue(
  //       `discount`,
  //       0
  //     );
  //     toastr.error("Validation", "Discount should be less than amount");
  //   }

  // }, [formik.values])

  const handleDiscountValue = (e) => {
    const data = formik.values?.amount;
    if (formik.values?.discount_type === "%") {
      if (e.target.value < 100) {
        formik.setFieldValue(
          `discount`,
          e.target.value.match(regex)[0]
        );
      } else {
        formik.setFieldValue(
          `discount`,
          0
        );
        toastr.error("Validation", "Discount should be less than 100 %");
      }
    } else {
      if (e.target.value < Number(data)) {
        formik.setFieldValue(
          `discount`,
          e.target.value.match(regex)[0]
        );
      } else {
        formik.setFieldValue(
          `discount`,
          0
        );
        toastr.error("Validation", "Discount should be less than amount");
      }
    }
  };

  return (
    <div className="batch-render-comp renderd-comp">
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="col-sm-12 px-sm-18 px-3 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-8">
              <div className="form-group batch-input-border">
                <InputField
                  mandatory
                  type="text"
                  {...{
                    formik,
                    title: "Bulk Billing",
                    name: `batch_name`,
                    placeholder: "Batch Name",
                    checkValidation: true,
                    value: formik.values?.batch_name,
                  }}
                  error={formik?.errors["batch_name"]}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title="Amount Source" />
                  <InfoTooltip text="Manual = enter amounts yourself. Account = pull amounts from account records. Previous Amount = re-bill past charges matching your filters. File = upload a spreadsheet of amounts." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <div className="charge-type">
                  {types?.map((type, idx) => (
                    <span
                      className={
                        type === "Previous Amount" ? "col-sm-3" : "col-sm-3"
                      }
                      style={
                        type === show
                          ? { background: "#2555ef", color: "white" }
                          : {}
                      }
                      key={idx}
                      onClick={() => {
                        setShow(type);
                        formik.setFieldValue("batch_type", show?.toLowerCase());
                      }}
                      {...{
                        formik,
                        name: `batch_type`,
                        value: formik.values?.batch_type,
                      }}
                    >
                      {type}
                    </span>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-12">
              <div className="form-group">
                <InputField
                  // mandatory
                  type="text"
                  {...{
                    formik,
                    title:
                      "Charge Description (will show on the member statement)",
                    name: `description`,
                    placeholder: "",
                    checkValidation: true,
                    value: formik.values?.description,
                  }}
                  style={{
                    backgroundColor: "#F3F6F9",
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4 justify-content-start">
            <Col className="col-12 col-md-4 charge-tab">
              <div
                className="form-group"
                style={{
                  zIndex: "1111",
                }}
              >
                <LabelField title={"Ledger Account"} />
                <Select
                  mandatory={false}
                  {...{
                    formik,
                    name: `Ledger`,
                    touched: "Ledger",
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={legderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getLedgerOnChange}
                  value={{
                    label: formik.values?.Ledger?.name,
                    value: formik.values?.Ledger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
                {formik?.values["batchSubmit"] && formik?.errors["Ledger"] ? (
                  <HintField error={formik?.errors["Ledger"]} />
                ) : null}
              </div>
            </Col>
            <Col className="col-12 col-md-4 charge-tab">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `SubLedger`,
                    checkValidation: false,
                  }}

                  isClearable={formik.values?.SubLedger?.id ?? false}
                  // isClearable={true}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLegderOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={getSubLedgerOnChange}
                  value={{
                    label: formik.values?.SubLedger?.name,
                    value: formik.values?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
                {formik?.touched["SubLedger"] && formik?.errors["SubLedger"] ? (
                  <HintField error={formik?.errors["SubLedger"]} />
                ) : null}
              </div>
            </Col>
          </Row>



          {/* <Row className="form-row sm-12 mb-0">
            <Col className="col-sm-12 px-0">
              <TextareaField
                mandatory={formik?.values?.require_notes ? true : false}
                {...{
                  formik,
                  title: "Add Note",
                  name: `note`,
                  placeholder: "Note text",
                  style: { resize: "none" },
                  checkValidation: true,
                  onChange: (value) => {
                    formik.setFieldValue(`note`, value);
                  },
                }}
                defaultValue={
                  formik?.values?.note
                }
              />
            </Col>
          </Row>
          <MyCheckbox
            {...{
              formik,
              title: "Add Note",
              name: `comment_checkbox`,
            }}
            // disabled={formik.values.type === "edit-charge" ? true : false}
            title="Comment on invoice"
            handleSubmit
            handlechange={(event) => {
              formik.setFieldValue(
                `comment_checkbox`,
                event.target.checked
              );
            }}
            checked={formik?.values?.comment_checkbox}
          /> */}
          <Row className="form-row sm-12 mb-4 justify-content-start">
            <Col className="col-12 col-md-4 charge-tab">

              <LabelField
                title="CSV file"
                hint="Upload a CSV file matching one of the example formats below. Each row becomes a charge (and optionally a payment) in this batch."
                hintPlacement="right"
              />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="file"
                  name="charges_file"
                  onChange={(e) => {
                    console.log('✅ File input triggered');
                    console.log('Captured file:', e.target.files[0]);
                    setFieldValue('charges_file', e.target.files[0]);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4 justify-content-start">
            <Col className="col-12 col-md-4 charge-tab">

              <a href="/chargesBulkExample.csv" download>
                click to download example CSV for charges only
              </a>


            </Col>

          </Row>
          <Row className="form-row sm-12 mb-4 justify-content-start">
            <Col className="col-12 col-md-4 charge-tab">

              <a href="/chargesBulkExampleWithPayments.csv" download>
                click to download example CSV file for charges + payments
              </a>


            </Col>

          </Row>
        </div>
      </form>
    </div>
  );
};

export default File;
